import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin)

const useArtistsThumbSwiper = () => {
  const swiperName = '.artists-thumb__swiper';
  const swiperEl = document.querySelector(swiperName);

  if (!swiperEl) return;

  const slides = swiperEl.querySelectorAll('.swiper-slide');

  new Swiper(swiperEl, {
    slidesPerView: 'auto',
    spaceBetween: 20,
    // loop: true,
    navigation: {
      nextEl: '.artists-thumb__swiper--next',
      prevEl: '.artists-thumb__swiper--prev',
    },
    breakpoints: {
      768: {
        spaceBetween: 32,
      },
      1024: {
        spaceBetween: 40,
      }
    },
    on: {
			breakpoint(swiper) {
				swiperEl.style.setProperty('--swiper-space-between', `${swiper.params.spaceBetween}px`)
				swiperEl.style.setProperty('--swiper-slides-per-view', `${slides.length}`)
			}
		}
  })
}

const useArtistsAnchor = () => {
  const anchors = document.querySelectorAll('.artists-thumb__image')
  if (!anchors.length) return

  anchors.forEach((anchor, index) => {
    anchor.addEventListener('click', () => {
      const offsetY = (document.querySelector('.header')?.getBoundingClientRect().height || 80) + 20

      gsap.to(window, {
				duration: 1,
				ease: 'power4.inOut',
				scrollTo: {
					y: `.artists-list__item:nth-child(${index + 1})`,
          offsetY
				}
			})
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  useArtistsThumbSwiper()
  useArtistsAnchor()
})